import { useState, useEffect } from 'react';

export const useAdvancedScroll = () => {
  const [scrollData, setScrollData] = useState({
    scrollY: 0,
    scrollProgress: 0,
    scrollVelocity: 0,
    isScrolling: false
  });

  useEffect(() => {
    let lastScrollY = 0;
    let lastTimestamp = 0;
    let timeoutId: NodeJS.Timeout;
    
    // Cache layout dimensions to avoid forced reflow
    let cachedDocHeight = document.documentElement.scrollHeight - window.innerHeight;
    
    const updateCachedDimensions = () => {
      cachedDocHeight = document.documentElement.scrollHeight - window.innerHeight;
    };

    const updateScrollData = () => {
      const currentScrollY = window.scrollY;
      const currentTimestamp = Date.now();
      
      const scrollProgress = Math.min(currentScrollY / cachedDocHeight, 1);
      const scrollVelocity = currentTimestamp > lastTimestamp 
        ? (currentScrollY - lastScrollY) / (currentTimestamp - lastTimestamp)
        : 0;

      setScrollData({
        scrollY: currentScrollY,
        scrollProgress,
        scrollVelocity,
        isScrolling: true
      });

      lastScrollY = currentScrollY;
      lastTimestamp = currentTimestamp;

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setScrollData(prev => ({ ...prev, isScrolling: false }));
      }, 100);
    };

    const throttledUpdate = () => {
      requestAnimationFrame(updateScrollData);
    };

    window.addEventListener('scroll', throttledUpdate, { passive: true });
    window.addEventListener('resize', updateCachedDimensions, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', throttledUpdate);
      window.removeEventListener('resize', updateCachedDimensions);
      clearTimeout(timeoutId);
    };
  }, []);

  return scrollData;
};